const ScreenShareMessageType = {
  JOIN_CODE: 'screen-sharing-join-code',
  GET_JOIN_CODE: 'screen-sharing-get-join-code',
  MODERATOR_ACTIVE: 'screen-sharing-moderator-active',
  CHANNEL_ACTIVE: 'screen-sharing-channel-active',
  ERROR: 'screen-sharing-error',
  STREAM_CONNECTED: 'screen-sharing-stream-connected',
  STREAM_PAUSED: 'screen-sharing-stream-paused',
  STREAM_DISCONNECTED: 'screen-sharing-stream-disconnected',
  CHANNEL_CONFIG: 'screen-sharing-channel-config',
  JOIN_MODERATED_SESSION: 'screen-sharing-join-moderated-session',
  RETURN_TO_STANDARD: 'screen-sharing-return-to-standard',
  HEARTBEAT: 'heartbeat'
};

module.exports = ScreenShareMessageType;
